import { useParams } from 'react-router-dom';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';

interface Props {
  periodId: string;
  cartId: string;
}

const useRfqQuoteUrlParams = (): Props => {
  const { periodId } = useParams<{ periodId: string }>();

  const query = useQueryParams();
  const cartId = query.get('cartId') || '';

  return { periodId, cartId };
};

export default useRfqQuoteUrlParams;
